<template>
  <NewsCategoryBase
    :title="{ 'zh-CN': '行业资讯', 'en-US': 'Industry News' }"
    route-path="/news/industry"
    category="industry"
  />
</template>
<script>
import NewsCategoryBase from "./NewsCategoryBase.vue";
export default { name: "IndustryNewsPage", components: { NewsCategoryBase } };
</script>
